import * as angular from 'angular';
import { ngStorage } from 'ngstorage';
import { IBundleComponentItemWithProducts, IBundleVariation } from '../../models/models';
import { BundlesService } from '../../services/bundles.service';

class EditBundleItemsComponent {

    public static $inject = [
        'bundlesService',
        '$localStorage',
        '$uibModal'
    ];

    public componentList: IBundleComponentItemWithProducts[];
    public waiting: boolean;

    public form: ng.IFormController;
    public countryID: string;

    public treeOptions = {
        dropped: this.dropped.bind(this)
    };

    private defaultComponent: IBundleComponentItemWithProducts = {
        Name: null,
        Quantity: 1,
        Variations: []
    };

    constructor(
        private bundlesService: BundlesService,
        private $localStorage: ngStorage.StorageService,
        private $uibModal: ng.ui.bootstrap.IModalService
    ) {
    }

    public async $onInit() {
        this.countryID = this.$localStorage.retailerAuthorizationData.countryID;
    }

    public getVariationImage(id: string): string {
        return this.bundlesService.getVariationImageUrl(id);
    }

    public nameChanged(control: ng.INgModelController, component: IBundleComponentItemWithProducts) {
        control.$setValidity('required', !!component.Name);
        if (component.errors) {
            component.errors.name = !component.Name;
        }
    }

    public quantityChanged(control: ng.INgModelController, value: number) {
        control.$setValidity('required', !isNaN(value));
        control.$setValidity('min', isNaN(value) || value > 0);
        control.$setValidity('max', isNaN(value) || value <= 30);
    }

    public removeItem(variation: IBundleVariation, component: IBundleComponentItemWithProducts) {
        component.Variations = component.Variations.filter((variant) => variant !== variation);
        this.form.$setDirty();
    }

    public async addItems(component: IBundleComponentItemWithProducts, index: number) {
        try {
            const products: IBundleVariation[] = await this.$uibModal.open({
                component: 'addItemsPopupComponent',
                resolve: {
                    selectedItems: () => [...component.Variations],
                    componentName: () => component.Name,
                    countryID: () => this.countryID,
                    disabledVariationIDs: () => this.getDisabledVariationIDs(index)
                },
                backdrop: 'static',
                windowClass: 'modal984 modal-design-v2'
            }).result;

            if (products) {
                component.Variations = products;
            }
            if (component.errors && component.errors.noVariations) {
                component.errors.noVariations = component.Variations.length === 0;
            }
            this.form.$setDirty();

        } catch (error) {
            return;
        }
    }

    public removeComponent(component: IBundleComponentItemWithProducts) {
        this.componentList = this.componentList.filter((item) => item !== component);
        this.form.$setDirty();
    }

    public addComponent() {
        this.componentList.push({
            ...this.defaultComponent,
            Variations: []
        });
        this.form.$setDirty();
    }

    private dropped(event: any) {
        if (event.source.index !== event.dest.index) {
            this.form.$setDirty();
        }
    }

    private getDisabledVariationIDs(excludedComponentIndex: number): string[] {
        if (this.componentList.length > 1) {
            return this.componentList
              .filter((component, index) => index !== excludedComponentIndex)
              .map((component) => component.Variations)
              .reduce((previousValue, currentValue) => previousValue.concat(currentValue))
              .map((variation) => variation.VariationID);
        } else {
            return [];
        }
    }
}

angular.module('naut').component('editBundleItemsComponent', {
    template: require('./edit-bundle-items.component.html'),
    controller: EditBundleItemsComponent,
    controllerAs: 'ctrl',
    bindings: {
        componentList: '=',
        waiting: '<'
    },
    require: {
        form: '^form'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/bundles/components/edit-bundle-items/edit-bundle-items.component.ts